export type IAddressData = {
    Adresselinie1: string
    Adresselinie2: string
    Adresselinie3: string
    Postdistrikt: string
    Postnummer: string
}

export class Address {
    id = 0

    addressLine1 = ''

    addressLine2 = ''

    addressLine3 = ''

    postDistrict = ''

    postNumber = ''

    static build(data: IAddressData): Address {
        const address = new Address()

        address.addressLine1 = data && data.Adresselinie1
        address.addressLine2 = data && data.Adresselinie2
        address.addressLine3 = data && data.Adresselinie3
        address.postDistrict = data && data.Postdistrikt
        address.postNumber = data && data.Postnummer

        return address
    }
}
